module.exports = __webpack_public_path__ + "img/T5-B-rc9.7ce22eee.png";